import Vue from 'vue'
import { fetchPostService, fetchGetFile } from '@modules/api'

const state = {
  title: '',
  selected: [],
  items: [],
  emailList: [],
  emailSeparator: navigator.appVersion.indexOf('Mac') !== -1 ? ',' : ';',
  emailMailto: '',
  emailToList: [],
  emailCcList: [],
  total: 0
}

const getters = {
  getTitle: state => state.title,
  getItems: state => state.items,
  getSelected: state => state.selected,
  getTotal: state => state.total,
  getEmailSeparator: state => state.emailSeparator,
  getEmailList: state => state.emailList,
  getEmailMailto: state => state.emailMailto,
  getEmailToList: state => state.emailToList,
  getEmailCcList: state => state.emailCcList,
  getOffset: state => state.items.length
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_TOTAL: (state, number) => {
    state.total = number || 0
  },
  UPDATE_ITEMS: (state, array) => {
    state.items = [ ...array ]
  },
  UPDATE_EMAIL_SEPARATOR: (state, string) => {
    state.emailSeparator = string
  },
  UPDATE_EMAIL_MAILTO: (state, string) => {
    state.emailMailto = string
  },
  UPDATE_EMAIL_LIST: (state, array) => {
    state.emailList = [ ...array ]
  },
  UPDATE_EMAIL_TO_LIST: (state, array) => {
    state.emailToList = [ ...array ]
  },
  UPDATE_EMAIL_CC_LIST: (state, array) => {
    state.emailCcList = [ ...array ]
  },
  ADD_ITEMS: (state, array) => {
    state.items = [...state.items, ...array]
  },
  UPDATE_ITEM_ACTIVE: (state, { active, guid }) => {
    const index = state.items.findIndex(item => item.guid === guid)
    if (index > -1) {
      Vue.set(state.items[index], 'active', active)
    }
  },
  UPDATE_SELECTED: (state, array) => {
    state.selected = [ ...array ]
  }
}

const actions = {
  updateState: ({ dispatch }, { title, items }) => {
    dispatch('updateTitle', title)
    dispatch('updateItems', items)
  },
  updateTitle: ({ commit, dispatch }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateTotal: ({ commit, dispatch }, total) => {
    commit('UPDATE_TOTAL', total)
  },
  updateItems: ({ commit, dispatch }, items) => {
    commit('UPDATE_ITEMS', items)
    dispatch('updateSelected')
  },
  updateEmailSeparator: ({ commit, dispatch }, separator) => {
    commit('UPDATE_EMAIL_SEPARATOR', separator)
    dispatch('updateEmailMailto')
  },
  updateEmailMailto: ({ state, commit }) => {
    // console.log(state.emailSeparator)
    const joinToList = state.emailToList.join(state.emailSeparator)
    const joinCcList = state.emailCcList.join(state.emailSeparator)
    const url = `mailto:${joinToList}?cc=${joinCcList}`
    commit('UPDATE_EMAIL_MAILTO', url)
  },
  updateEmailList: ({ state, commit, dispatch }) => {
    commit('UPDATE_EMAIL_LIST', state.selected.map(user => {
      return user.email
    }))
    dispatch('updateEmailToList', state.selected.filter(user => {
      if (user.sendingEmail === 'to') return user.email
    }).map(user => user.email))
    dispatch('updateEmailCcList', state.selected.filter(user => {
      if (user.sendingEmail === 'cc') return user.email
    }).map(user => user.email))
    dispatch('updateEmailMailto')
  },
  updateEmailToList: ({ commit }, emails) => {
    commit('UPDATE_EMAIL_TO_LIST', emails)
  },
  updateEmailCcList: ({ commit }, emails) => {
    commit('UPDATE_EMAIL_CC_LIST', emails)
  },
  addItems: ({ commit, dispatch }, users) => {
    commit('ADD_ITEMS', users.items)
    dispatch('updateTotal', users.total)
    dispatch('updateSelected')
  },
  updateSelected: ({ commit, state }) => {
    const selected = []
    state.items.forEach(item => {
      if (item.active) {
        selected.push({ guid: item.guid, email: item.email || '', sendingEmail: item.sendingEmail || 'to' })
      }
    })
    commit('UPDATE_SELECTED', selected)
  },
  updateAllItemsActive: ({ dispatch, state }, status) => {
    state.items.forEach(item => {
      dispatch('updateItemActive', { active: status, guid: item.guid })
    })
  },
  updateItemActive: ({ commit, dispatch }, { active, guid }) => {
    commit('UPDATE_ITEM_ACTIVE', { active, guid })
    dispatch('updateSelected')
  },
  postSelectedUsers ({ state }) {
    // POST
    fetchPostService('export-contact-list', { selected: state.selected }).then(({ data }) => {
      fetchGetFile({
        path: data.path,
        file: data.file
      })
    })
  },
  postAllUsers ({ state }) {
    // POST
    fetchPostService('export-all-contact-list', { selected: state.items }).then(({ data }) => {
      fetchGetFile({
        path: data.path,
        file: data.file
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
